// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"1229":"ReservationDetailsExpressCheckout","5314":"CashierExpressCheckoutWidget"}[chunkId] || chunkId) + ".chunk.min.js";
};